import { Backdrop, h3Style, style, StyledModal } from "./styles";
import { Box } from "@mui/system";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";

const SuccessFailedModal: React.FC<{
  open: boolean;
  onClose: any;
  isError: boolean;
  successMessage?: string;
  failMessage?: string;
}> = ({ open, onClose, isError, successMessage, failMessage }) => {
  return (
    <StyledModal
      aria-labelledby="unstyled-modal-title"
      aria-describedby="unstyled-modal-description"
      open={open}
      onClose={() => onClose(false)}
      BackdropComponent={Backdrop}
    >
      {isError ? (
        <Box sx={style}>
          <ErrorIcon style={{ color: "red", fontSize: "80px" }} />
          <h3
            style={{ ...h3Style, textAlign: "center" }}
            id="unstyled-modal-description"
          >
            {failMessage ? failMessage : "User with that email already exist"}
          </h3>
        </Box>
      ) : (
        <Box sx={style}>
          <CheckCircleIcon style={{ color: "green", fontSize: "80px" }} />
          <h3
            style={{ ...h3Style, textAlign: "center" }}
            id="unstyled-modal-description"
          >
            {successMessage ? successMessage : "User Invited"}
          </h3>
        </Box>
      )}
    </StyledModal>
  );
};

export default SuccessFailedModal;
